<template>
    <img :src="CardService.getDexTypeIcon(type)" alt="" class="type-icon">
</template>

<script>
import CardService from "../../CardService";

export default {
    name: "TypeIcon",
    computed: {
        CardService() {
            return CardService
        }
    },
    props: ["type"]
};
</script>


<style scoped lang="scss">
.type-icon {
    max-height: 1.5em;
}
</style>
